import React from 'react';

const LinkGoogleAccountSvg = (props) => (
    <svg
        width="253"
        height="141"
        viewBox="0 0 253 141"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_dd)">
            <circle cx="70.5" cy="69.5" r="46.5" fill="#F05537" />
        </g>
        <g filter="url(#filter1_dd)">
            <circle cx="182.5" cy="69.5" r="46.5" fill="white" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.449 58.9328C73.0911 57.8602 77.7263 59.8006 80.3061 63.4765L59.7862 68.2112C60.491 63.7785 63.8068 60.0054 68.449 58.9328ZM80.4207 76.3579C78.8686 78.6558 76.4764 80.3949 73.5598 81.0648C68.8864 82.1443 64.2235 80.1693 61.6541 76.4517L82.24 71.6997L85.5906 70.9256L92 69.4469C91.9618 68.0688 91.7882 66.67 91.4653 65.278C88.8578 53.9795 77.5805 46.9331 66.2789 49.5434C54.9808 52.1502 47.9325 63.4245 50.5435 74.723C53.151 86.0216 64.4283 93.0646 75.7299 90.4577C82.3893 88.92 87.5662 84.3728 90.1667 78.5899L80.4207 76.3579Z"
            fill="white"
        />
        <g filter="url(#filter2_dd)">
            <ellipse cx="126.5" cy="71" rx="27.5" ry="28" fill="white" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M119 74V68V66H121H126V68H121V74H126V76H119V75V74ZM130 70H124V72H130V70ZM128 66H133H135V68V74V75V76H128V74H133V68H128V66Z"
            fill="#4B4D63"
        />
        <g clipPath="url(#clip0)">
            <path
                d="M202.143 69.4822C202.143 68.0547 202.027 66.6195 201.78 65.2151H181.984V73.3018H193.32C192.85 75.91 191.338 78.2171 189.125 79.6832V84.9303H195.888C199.86 81.2728 202.143 75.8714 202.143 69.4822Z"
                fill="#4285F4"
            />
            <path
                d="M181.984 90.0001C187.645 90.0001 192.418 88.1405 195.897 84.9305L189.133 79.6834C187.251 80.9643 184.822 81.6896 181.992 81.6896C176.517 81.6896 171.874 77.9935 170.208 73.0242H163.229V78.4333C166.792 85.5247 174.049 90.0001 181.984 90.0001Z"
                fill="#34A853"
            />
            <path
                d="M170.2 73.0239C169.321 70.4158 169.321 67.5916 170.2 64.9835V59.5744H163.229C160.252 65.5082 160.252 72.4992 163.229 78.4331L170.2 73.0239Z"
                fill="#FBBC04"
            />
            <path
                d="M181.984 56.3105C184.976 56.2642 187.868 57.3908 190.035 59.4588L196.028 53.4632C192.233 49.8982 187.197 47.9383 181.984 48C174.049 48 166.792 52.4755 163.229 59.5745L170.201 64.9837C171.859 60.0066 176.509 56.3105 181.984 56.3105Z"
                fill="#EA4335"
            />
        </g>
        <defs>
            <filter
                id="filter0_dd"
                x="0"
                y="0"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_dd"
                x="112"
                y="0"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_dd"
                x="75"
                y="20"
                width="103"
                height="104"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0">
                <rect
                    width="41.1429"
                    height="42"
                    fill="white"
                    transform="translate(161 48)"
                />
            </clipPath>
        </defs>
    </svg>
);

LinkGoogleAccountSvg.displayName = 'LinkGoogleAccountSvg';
export default LinkGoogleAccountSvg;
